<template>
    <section class="section-hero section-shaped my-0">
        <div class="container shape-container justify-content-start">
            <div class="row">
                <div class="col px-0 card-group">
                    <div class="card bg-dark mb-3 col-sm-8">
                        <div class="card-body" >
                            <h3>Success City</h3>
                            <p class="location-color">Ayensu Road</p>
                        </div>
                    </div>
                    <div class="card bg-default mb-3 col-sm-4">
                        <div class="card-body p-2">
                            <h3 class="text-center" style="color: #f2f2f2; font-size: 1.5rem;"># of Rooms</h3>
                            <p class="text-center" style="color: #f2f2f2; font-size: 1.3rem;">14</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col px-0 card-group">
                    <div class="card bg-dark mb-3 col-sm-8">
                        <div class="card-body" >
                            <h3>Executive Hostel</h3>
                            <p class="location-color">School Bus Road</p>
                        </div>
                    </div>
                    <div class="card bg-default mb-3 col-sm-4">
                        <div class="card-body p-2">
                            <h3 class="text-center" style="color: #f2f2f2; font-size: 1.5rem;"># of Rooms</h3>
                            <p class="text-center" style="color: #f2f2f2; font-size: 1.3rem;">24</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col px-0 card-group">
                    <div class="card bg-dark mb-3 col-sm-8">
                        <div class="card-body" >
                            <h3>Jilson Hostel</h3>
                            <p class="location-color">Kwaprow</p>
                        </div>
                    </div>
                    <div class="card bg-default mb-3 col-sm-4">
                        <div class="card-body p-2">
                            <h3 class="text-center" style="color: #f2f2f2; font-size: 1.5rem;"># of Rooms</h3>
                            <p class="text-center" style="color: #f2f2f2; font-size: 1.3rem;">12</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {};
</script>
<style>
    .location-color{
        color: #f3f2f2;
    }

    h3.color-white {
        color: #f3f2f2 !important;
        font-size: 1.5rem;
    }

</style>